export const PAGE_SIZE = 20;

export const COMPLETED_STATUSES = new Set(["SelfApproved", "Approved"]);
